import React from 'react';
import { Box } from '~/components/gluestack/box';
import { HStack } from '~/components/gluestack/hstack';
import { RelativeTime } from '~/components/ui/RelativeTime';
import { Member } from '~/models/Member';
import { MemberDetails } from '~/models/MemberDetails';

interface IPresenceIndicatorProps {
  member: Member | MemberDetails;
  className?: string;
  showLastSeen?: boolean;
}

export function PresenceIndicator({ member, className, showLastSeen }: IPresenceIndicatorProps) {
  const dotColor = member.IsOnline ? 'bg-green-500' : member.IsAway ? 'bg-yellow-500' : null;
  const lastSeenDate = showLastSeen ? member.LastSeenDate : null;

  if (lastSeenDate) {
    return (
      <HStack
        className={`flex-shrink-0 items-center gap-1 rounded-full bg-background-100 px-1.5 py-0.5 ${className || ''}`}>
        {dotColor && <Box className={`size-2.5 rounded-full ${dotColor}`} />}
        <RelativeTime date={lastSeenDate} tiny textOnly className="text-xs text-typography-500" />
      </HStack>
    );
  }

  if (!dotColor) {
    return null;
  }

  return <Box className={`size-3 flex-shrink-0 rounded-full ${dotColor} ${className || ''}`} />;
}
